import { get } from "lodash";
import htmlToFormattedText from "html-to-formatted-text";

export const PAGE_COUNT = 10; // for pagination
export const BEST_PRACTICES_PAGE_COUNT = 18;
export const modifyDataForPost = data => {
  const modifiedData = {
    category: get(data, "category"),
    description: htmlToFormattedText(get(data, "description")),
    groupCode: get(data, "groupCode"),
    groupRoles: get(data, "rolesList", [])
      .filter(value => value.checked)
      .map(value => {
        return { roleId: +value.roleId };
      }),
    name: htmlToFormattedText(get(data, "name", null)),
    parentId: +get(data, "parentId")
  };

  get(data, "id") && (modifiedData["id"] = get(data, "id"));

  return modifiedData;
};

export const modifyDataForCreateUser = data => {
  const rolesList = [];
  get(data, "rolesList", []).forEach(value => {
    value.checked && rolesList.push(value.roleId);
  });
  return {
    address: "",
    designation: htmlToFormattedText(get(data, "designation")),
    active: get(data, "active"),
    email: htmlToFormattedText(get(data, "email")),
    groupId: get(data, "groupId"),
    roles: rolesList,
    mobileNumber: get(data, "mobileNumber"),
    name: htmlToFormattedText(get(data, "name")),
    password: get(data, "password"),
    key: get(data, "key"),
    userID: get(data, "userID"),
    organization: get(data, "organisation"),
    alternateMobileNumber: get(data, "alternateMobileNumber"),
    isIIGAccess: get(data, "iigAccess")
  };
};

export const modifyDataForBestPractices = data => {
  return {
    bestPracticeId: get(data, "id"),
    groupId: get(data, "groupId"),
    title: htmlToFormattedText(get(data, "title")),
    description: htmlToFormattedText(get(data, "description")),
    documents: get(data, "files", []).map(value => {
      return value.id;
    })
  };
};

export const modifyDataForCreateRole = data => {
  const modifyData = {
    description: htmlToFormattedText(get(data, "description", "")),
    name: htmlToFormattedText(get(data, "name", "")),
    permissionIds: get(data, "permissionIds", []).map(value => {
      return +value;
    }),
    groupCategories: get(data, "groupCategories", []).map(item => item.value),
    preselect: get(data, "preselect", false)
  };

  get(data, "id") && (modifyData["id"] = get(data, "id", null));

  return modifyData;
};
